import gql from 'graphql-tag';

export default gql`
	mutation usernameAvailable($email: String!) {
		usernameAvailable(account_user_name: $email) {
			available
		}
	}
`;
